import {Offer} from '@daedalus/core/src/offer/types/offer'

/**
 * Checks if an offer is eligible for DealFreeze based on the defined criteria.
 * Returns true if the offer is eligible, false otherwise.
 * @param tags - The offer tags to be checked for eligibility.
 * @returns A boolean indicating whether the offer is eligible for DealFreeze.
 */
export const isOfferEligibleForDealFreeze = (tags: Offer['tags'] = []) =>
  tags?.includes('deal_freeze')
